/** @module  */
import mapi1 from './lib/mapi.js'
import * as i18n from './lib/i18n_esm.js';
import xGclid from './lib/gclid.js';

var tT;
if (globalThis == undefined) {
    tT = window;
} else {
    tT = globalThis;
}
if (typeof urlParams != 'object') {
    var urlParams = {};
    try {
        (function () {
            var e,
                a = /\+/g,  // Regex for replacing addition symbol with a space
                r = /([^&=]+)=?([^&]*)/g,
                d = function (s) { return decodeURIComponent(s.replace(a, " ")); },
                q = window.location.search.substring(1);
            while (e = r.exec(q)) {
                urlParams[d(e[1])] = d(e[2]);
            }
        })();
    } catch (err) {
        // nothing
    }
    tT.urlParams = urlParams;
}

window.dataLayer = window.dataLayer || [];
window.gtag = function () {
    dataLayer.push(arguments);
}


let mapi = mapi1;
export { mapi, i18n, xGclid }; 